import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Chat from "@/pages/Chat";
import AdminDashboard from "@/pages/AdminDashboard";
import VendorBooking from "@/pages/VendorBooking";
import PublicEcard from "@/pages/PublicEcard";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full border-4 border-emerald-900/15 border-t-emerald-900 animate-spin" />
        <p className="text-sm text-zinc-500">Loading Aarogya Assist…</p>
      </div>
    </div>
  );
}

function RequireAuth({ children, role }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  const allowed = role === "admin" ? ["admin", "master_admin"] : [role];
  if (role && !allowed.includes(user.role)) {
    return <Navigate to={["admin", "master_admin"].includes(user.role) ? "/admin" : "/"} replace />;
  }
  return children;
}

function RootRedirect() {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <LoadingScreen />;
  if (user && ["admin", "master_admin"].includes(user.role)) return <Navigate to="/admin" replace />;
  return <Landing />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/vendor/:token" element={<VendorBooking />} />
          <Route path="/ecard" element={<PublicEcard />} />
          <Route
            path="/chat"
            element={
              <RequireAuth role="employee">
                <Chat />
              </RequireAuth>
            }
          />
          <Route
            path="/admin"
            element={
              <RequireAuth role="admin">
                <AdminDashboard />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
